// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2nGLz","buttons":"PendingPaymentAlert_buttons__cLt1v"};